import {
  Line,
  LineChart,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  Brush,
  ResponsiveContainer
} from 'recharts';

const TooltipVolPro = ({active, payload, label}) => {
  if (active && payload && payload.length) {
    return (
      <div className="custom-tooltip bg-white p-2 rounded-md shadow-md">
        <p className="label">{label}</p>
        <p className="label">{`${payload[0].name} : RM ${formatCurrency(payload[0].value.toFixed(2))}`}</p>
      </div>
    );
  }
  return null;
};
const OrderTooltip = ({active, payload, label}) => {
  if (active && payload && payload.length) {
    return (
      <div className="custom-tooltip bg-white p-2 rounded-md shadow-md">
        <p className="label">{label}</p>
        <p className="label">{`${payload[0].name} : ${payload[0].value} Order(s)`}</p>
      </div>
    );
  }
  return null;
};
const formatCurrency = (value) => {
    if (value === null || value === undefined || isNaN(parseFloat(value))) {
      return "0.00";
    }
    return parseFloat(value).toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    });
};
const BehaviourGraph = ({behaviourData}) => {
  return(
    <div className="p-4 mb-4">
      <ResponsiveContainer width="100%" height={200}>
        <LineChart
          data={behaviourData}
          syncId="anyId"
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="process_month" className='hidden' />
          <YAxis
          // padding={{top:20}} 
          label={{ value: 'Total Volume (MYR)', angle: -90, position: 'insideLeft', style:{ textAnchor: 'middle' } }}
          tickFormatter={(value) => {
            if (value >= 1000000) {
              return `${(value / 1000000).toFixed(1)}M`;
            } else if (value >= 1000) {
              return `${(value / 1000).toFixed(0)}K`;
            } else {
              return value;
            }
          }} />
          <Tooltip content={<TooltipVolPro />} />
          <Line type="monotone" dataKey="Volume" stroke="#7cb5ec" fill="#7cb5ec" />
        </LineChart>
      </ResponsiveContainer>
      <ResponsiveContainer width="100%" height={200}>
        <LineChart
          data={behaviourData}
          syncId="anyId"
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="process_month" className='hidden'/>
          <YAxis label={{ value: 'Total Profit (MYR)', angle: -90, position: 'insideLeft',style:{ textAnchor: 'middle' }  }} 
          tickFormatter={(value) => {
            if (value >= 1000000) {
              return `${(value / 1000000).toFixed(1)}M`;
            } else if (value >= 1000) {
              return `${(value / 1000).toFixed(0)}K`;
            } else {
              return value;
            }
          }}
          />
          <Tooltip content={<TooltipVolPro />}/>
          <Line type="monotone" dataKey="Profit" stroke="#434348" fill="#434348" />
        </LineChart>
      </ResponsiveContainer>
      <ResponsiveContainer width="100%" height={200}>
        <LineChart
          data={behaviourData}
          syncId="anyId"
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="process_month" className='hidden'/>
          <YAxis label={{ value: 'Revenue (MYR)', angle: -90, position: 'insideLeft',style:{ textAnchor: 'middle' }  }} 
          tickFormatter={(value) => {
            if (value >= 1000000) {
              return `${(value / 1000000).toFixed(1)}M`;
            } else if (value >= 1000) {
              return `${(value / 1000).toFixed(0)}K`;
            } else {
              return value;
            }
          }}
          />
          <Tooltip content={<TooltipVolPro />}/>
          <Line type="monotone" dataKey="Revenue" stroke="#82ca9d" fill="#82ca9d" />
        </LineChart>
      </ResponsiveContainer>
      <ResponsiveContainer width="100%" height={200}>
        <LineChart
          data={behaviourData}
          syncId="anyId"
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="process_month" />
          <YAxis 
          label={{ 
            value: 'No. of Orders', 
            angle: -90, 
            position: 'insideLeft',
            offset:0,
            style:{ textAnchor: 'middle' } 
          }}
          tick={{ dx: -5 }}
          tickMargin={5} 
          minTickGap={10}/>
          <Tooltip content={<OrderTooltip />}/>
          <Line type="monotone" dataKey="Order" stroke="#90ed7d" fill="#90ed7d" />
          <Brush />
        </LineChart>
      </ResponsiveContainer>
    </div>
  )
}
export default BehaviourGraph;